import Cookies from 'js-cookie'
import Config from '@/config'

const TokenKey = Config.TokenKey

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token, rememberMe) {
  if (rememberMe) {
    return Cookies.set(TokenKey, token, { expires: Config.tokenCookieExpires })
  } else return Cookies.set(TokenKey, token)
}

export function removeToken() {
  Cookies.remove(TokenKey)
  Cookies.remove(TokenKey, { domain: window.location.hostname })
  Cookies.remove(TokenKey, { domain: ".xchengtech.cn" })
  Cookies.remove(TokenKey, { domain: "xchengtech.cn" })
}



// WEBPACK FOOTER //
// ./src/utils/auth.js